import i18next from 'i18next';
import { ReviewFormFieldError } from './types';
import { REVIEW_FORM_MAX_TEXT_LENGTH } from 'common/constants';

export enum MessageKeys {
  DO_TOTAL_SCORE = 'reviews.form.validation-errors.do-total-score',
  LEAVE_TEXT_CONTENT = 'reviews.form.validation-errors.leave-text-content',
  MAX_TEXT_CONTENT_IS_1500 = 'reviews.form.validation-errors.max-lenght',
  FAILED_TO_POST = 'reviews.form.validation-errors.failed-to-post',
  FILL_REQUIRED_FIELDS = 'reviews.form.validation-errors.fill-required-fields',
  REDUCE_REVIEW_LENGTH = 'reviews.form.validation-errors.reduce-review-length',
}

export enum ErrorKeys {
  FIELDS_MISSING = 'required-fields-are-missing',
  FAILED_TO_POST_ERROR = 'post-request-is-failed',
  MAX_LENGTH_EXCEEDED = 'text-is-too-long',
}

export type ValidatorFn<T> = (value: T) => ReviewFormFieldError[];
type FieldValidator<T> = (fieldKey: ReviewFormFieldError['fieldKey']) => ValidatorFn<T>;

export const totalScoreValidator: FieldValidator<number | null> = (fieldKey) => (value) => {
  const result = [];
  if (value === null || value === 0) {
    const message = i18next.t(MessageKeys.DO_TOTAL_SCORE);

    result.push({
      fieldKey,
      message,
      errorKey: ErrorKeys.FIELDS_MISSING,
    });
  }

  return result;
};

export const bodyTextValidator: FieldValidator<string | null> = (fieldKey) => (value) => {
  const result: ReviewFormFieldError[] = [];
  if (value === null || value.length === 0) {
    result.push({
      fieldKey,
      message: i18next.t(MessageKeys.LEAVE_TEXT_CONTENT),
      errorKey: ErrorKeys.FIELDS_MISSING,
    });
  } else if (value.length > REVIEW_FORM_MAX_TEXT_LENGTH) {
    const message = i18next.t(MessageKeys.MAX_TEXT_CONTENT_IS_1500, {
      length: REVIEW_FORM_MAX_TEXT_LENGTH,
    });
    result.push({ fieldKey, errorKey: ErrorKeys.MAX_LENGTH_EXCEEDED, message });
  }
  return result;
};

export const prosConsValidator: FieldValidator<string | null> = (fieldKey) => (value) => {
  const result = [];
  if (value !== null && value.length > REVIEW_FORM_MAX_TEXT_LENGTH) {
    const message = i18next.t(MessageKeys.MAX_TEXT_CONTENT_IS_1500, {
      length: REVIEW_FORM_MAX_TEXT_LENGTH,
    });
    result.push({ fieldKey, errorKey: ErrorKeys.MAX_LENGTH_EXCEEDED, message });
  }
  return result;
};
